const WA_LINK = 'https://wa.me/5511984333601?text=Ol%C3%A1%2C%20gostaria%20de%20uma%20consulta%20sobre%20direito%20imobili%C3%A1rio.';

const NAV_LINKS = [
  { label: 'Sobre', href: '#sobre' },
  { label: 'Atuação', href: '#atuacao' },
  { label: 'Diferenciais', href: '#diferenciais' },
  { label: 'Como Funciona', href: '#como-funciona' },
  { label: 'Contato', href: '#contato' },
];

const AREAS = [
  'Incorporação Imobiliária',
  'Regularização de Imóveis',
  'Levantamento de Área',
  'Retificação de Registro',
  'Unificação de Lotes',
  'Due Diligence',
  'Usucapião',
  'Inventários',
  'Assessoria em Compra e Venda',
];

export default function Footer() {
  const handleNavClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={{ background: '#ffffff' }}>
      {/* Top accent */}
      <div className="w-full h-px" style={{ background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)' }}></div>

      <div className="max-w-6xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">

          {/* Brand column */}
          <div className="lg:col-span-2">
            <img
              src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/dd0808434e8d654dd901725d75cf786a.png"
              alt="Uitalo Bruno Advocacia"
              className="h-16 w-auto object-contain mb-4"
            />
            <p className="font-serif text-sm italic font-semibold mb-1" style={{ color: '#D4AF37' }}>
              &ldquo;Não se trata de uma questão de sorte. É estratégia.&rdquo;
            </p>
            <p className="font-sans text-sm font-semibold leading-relaxed mt-4 max-w-xs" style={{ color: '#123B73' }}>
              Advocacia especializada em direito imobiliário estratégico. Segurança jurídica para seu patrimônio em São Paulo.
            </p>

            {/* Social */}
            <div className="flex items-center gap-3 mt-6">
              <a
                href="https://instagram.com/uitalo.adv"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center cursor-pointer transition-all duration-200"
                style={{ border: '1px solid rgba(212,175,55,0.6)', borderRadius: '2px', color: '#D4AF37' }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.background = 'rgba(212,175,55,0.1)'; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.background = 'transparent'; }}
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-sm"></i>
              </a>
              <a
                href={WA_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center cursor-pointer transition-all duration-200"
                style={{ border: '1px solid rgba(212,175,55,0.6)', borderRadius: '2px', color: '#D4AF37' }}
                onMouseEnter={(e) => { (e.currentTarget as HTMLAnchorElement).style.background = 'rgba(212,175,55,0.1)'; }}
                onMouseLeave={(e) => { (e.currentTarget as HTMLAnchorElement).style.background = 'transparent'; }}
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line text-sm"></i>
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-sans text-xs tracking-[3px] uppercase font-semibold mb-5" style={{ color: '#D4AF37' }}>
              Navegação
            </h4>
            <ul className="flex flex-col gap-3">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                    className="font-sans text-sm font-semibold cursor-pointer transition-colors duration-200 whitespace-nowrap"
                    style={{ color: '#0A2A52' }}
                    onMouseEnter={(e) => { (e.target as HTMLAnchorElement).style.color = '#D4AF37'; }}
                    onMouseLeave={(e) => { (e.target as HTMLAnchorElement).style.color = '#0A2A52'; }}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-sans text-xs tracking-[3px] uppercase font-semibold mb-5" style={{ color: '#D4AF37' }}>
              Áreas de Atuação
            </h4>
            <ul className="flex flex-col gap-3">
              {AREAS.map((area) => (
                <li key={area}>
                  <a
                    href="#atuacao"
                    onClick={(e) => { e.preventDefault(); handleNavClick('#atuacao'); }}
                    className="font-sans text-sm font-semibold cursor-pointer transition-colors duration-200 whitespace-nowrap"
                    style={{ color: '#123B73' }}
                    onMouseEnter={(e) => { (e.target as HTMLAnchorElement).style.color = '#D4AF37'; }}
                    onMouseLeave={(e) => { (e.target as HTMLAnchorElement).style.color = '#123B73'; }}
                  >
                    {area}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="w-full h-px mb-8" style={{ background: 'rgba(212,175,55,0.3)' }}></div>

        {/* Bottom bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="font-sans text-xs text-center sm:text-left" style={{ color: '#0A2A52' }}>
            <p>
              <strong>Uitalo Bruno Advocacia</strong> – OAB/SP
            </p>
            <p className="mt-0.5">R. Califórnia, 773 – Sala 7, Brooklin – São Paulo/SP</p>
          </div>
          <p className="font-sans text-xs text-center sm:text-right" style={{ color: '#123B73' }}>
            <a
              href="https://startdigital1.com.br"
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-2 cursor-pointer transition-colors duration-200 whitespace-nowrap"
              style={{ color: '#D4AF37' }}
              onMouseEnter={(e) => { (e.target as HTMLAnchorElement).style.color = '#C29B2E'; }}
              onMouseLeave={(e) => { (e.target as HTMLAnchorElement).style.color = '#D4AF37'; }}
            >
              Desenvolvido por Start Digital
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
